export const EnvValues = {
  API_URL: process.env.EXPO_PUBLIC_API_URL,
  // Those are possible to set but not required
  PARAM_DEV: process.env.EXPO_PUBLIC_PARAM_DEV,
  PARAM_DEBUG: process.env.EXPO_PUBLIC_PARAM_DEBUG,
  REGION: process.env.EXPO_PUBLIC_REGION,
  DEFAULT_LANG: process.env.EXPO_PUBLIC_DEFAULT_LANG,
  UI_LANGS: process.env.EXPO_PUBLIC_UI_LANGS,
  SHOW_ADMIN: process.env.EXPO_PUBLIC_SHOW_ADMIN,
  DEAL_TYPES: process.env.EXPO_PUBLIC_DEAL_TYPES,
  DEAL_LANG: process.env.EXPO_PUBLIC_DEAL_LANG,
  AVATAR: process.env.EXPO_PUBLIC_AVATAR,
  SERIAL_NUMBER: process.env.EXPO_PUBLIC_SERIAL_NUMBER,
  REDIRECTS_DISABLED: process.env.EXPO_PUBLIC_REDIRECTS_DISABLED,
  EXPO_PUBLIC_FORCE_SDK_MOCK: process.env.EXPO_PUBLIC_FORCE_SDK_MOCK,
} as const
